import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import { focusAtom } from 'jotai-optics';
import {
	PersistedUser,
	getPersistedUser,
	persistUserConsent,
} from '../../../utils';

export const userAtom = atom<PersistedUser>(getPersistedUser());

export const persistUserAtom = atom(
	(get) => get(userAtom),
	(get, set, newstr: PersistedUser) => {
		set(userAtom, newstr);
		if (newstr.email) {
			persistUserConsent('email', newstr.email, newstr.emailConsent);
		}

		if (newstr.sms) {
			persistUserConsent('sms', newstr.sms, newstr.smsConsent);
		}
	}
);

export const userEmailAtom = focusAtom(userAtom, (optic) =>
	optic.prop('email')
);

export const userEmailConsentAtom = focusAtom(userAtom, (optic) =>
	optic.prop('emailConsent')
);

export const userSMSAtom = focusAtom(userAtom, (optic) => optic.prop('sms'));

export const userSMSConsentAtom = focusAtom(userAtom, (optic) =>
	optic.prop('smsConsent')
);

export const persistedUserIdAtom = atom(
	localStorage.getItem('_ics_uid') ?? undefined
);

export const userIdAtom = atom(
	(get) => get(persistedUserIdAtom),
	(get, set, newStr: string) => {
		set(persistedUserIdAtom, newStr);
		localStorage.setItem('_ics_uid', newStr);
	}
);
